"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

var Mon386Tagline = function Mon386Tagline(_ref) {
  var merchandiseId = _ref.merchandiseId,
      activeTerm = _ref.activeTerm,
      currencyCode = _ref.currencyCode,
      getAdditionalContactsMonthlyCost = _ref.getAdditionalContactsMonthlyCost,
      merchandiseMap = _ref.merchandiseMap;
  var _merchandiseMap$merch = merchandiseMap[merchandiseId],
      additionalUnitMerchId = _merchandiseMap$merch.additionalUnitMerchId,
      edition = _merchandiseMap$merch.edition;
  var unitType = merchandiseMap[additionalUnitMerchId].units;

  var renderTaglineText = function renderTaglineText() {
    if (unitType === 'contact') {
      return _react.default.createElement(_FormattedMessage.default, {
        message: "mon386.contactsSubtext." + edition
      });
    } else if (unitType === 'user') {
      return _react.default.createElement(_FormattedMessage.default, {
        message: "mon386.usersSubtext." + edition
      });
    }

    return null;
  };

  var renderHelpText = function renderHelpText() {
    if (unitType === 'contact') {
      return _react.default.createElement(_FormattedJSXMessage.default, {
        message: "mon386.contactsSubtext.additionalContacts_jsx",
        elements: {
          Price: _PriceDisplay.default
        },
        options: {
          currencyCode: currencyCode,
          price: getAdditionalContactsMonthlyCost(merchandiseId, activeTerm)
        }
      });
    } else if (unitType === 'user') {
      return _react.default.createElement(_FormattedMessage.default, {
        message: "mon386.usersSubtext.freeUsers"
      });
    }

    return null;
  };

  return _react.default.createElement("div", {
    className: "m-top-2 text-center"
  }, _react.default.createElement(_Small.default, {
    use: "help",
    style: {
      lineHeight: '30px'
    }
  }, renderTaglineText()), _react.default.createElement(_UIHelpIcon.default, {
    style: {
      marginLeft: '4px'
    },
    size: "small",
    title: renderHelpText()
  }));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    getAdditionalContactsMonthlyCost: (0, _PricingSelectors.getAdditionalContactsMonthlyCostSelector)(state),
    merchandiseMap: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Mon386Tagline);

exports.default = _default;
module.exports = exports.default;